import { navMenuSection, tabletHideClass } from './navMenu.css';
import { Typography } from '../typography/typography';
import { NavMenuItemProps, NavMenuItem } from './NavMenuItem';

export type NavMenuSectionProps = {
  section: string;
  items: Array<NavMenuItemProps>;
};

export const NavMenuSection = (p: NavMenuSectionProps) => (
  <>
    <div className={navMenuSection}>
      <Typography
        variant="body"
        size="small"
        color="N-40"
        className={tabletHideClass}
      >
        {p.section}
      </Typography>
    </div>

    {p.items.map((item, i) => (
      <NavMenuItem key={i} {...item} />
    ))}
  </>
);
